import React from "react";
import { VatReturn } from "../../../model/accounting/vat/VatReturn.js";
import { FieldHeading } from "./FieldHeading.js";
import { FieldSubHeading } from "./FieldSubHeading.js";
import { FieldSubItem } from "./FieldSubItem.js";

type Props = {
  vatReturn: VatReturn;
};

/**
 * Generates table rows for the VAT report field 5.
 */
export const VatReportField5 = ({ vatReturn }: Props) => {
  const { total, expenses, reverseCharged, expensesItems, reverseChargedItems } = vatReturn;

  return (
    <>
      <FieldHeading
        label="Väli 5"
        description="Kokku sisendkäibemaksu summa, mis on seadusega lubatud maha arvata."
        total={total}
        itemsCount={2 + expensesItems.length + reverseChargedItems.length}
      />
      <FieldSubHeading label="Eesti kulud" total={expenses} itemsCount={expensesItems.length} />
      {expensesItems.map((queryItem) => (
        <FieldSubItem key={queryItem.id} queryItem={queryItem} />
      ))}
      <FieldSubHeading
        label="Tagastatav pöörd-KM (kulukirjed)"
        total={reverseCharged}
        itemsCount={reverseChargedItems.length}
      />
      {reverseChargedItems.map((queryItem) => (
        <FieldSubItem key={queryItem.id} queryItem={queryItem} />
      ))}
    </>
  );
};
